import React, { useState, lazy, Suspense, useEffect } from 'react'
import 'aframe'
import 'mind-ar/dist/mindar-image-aframe.prod.js'

import css from './App.module.scss'
import PageLoader from './components/PageLoader/PageLoader'
import MindARViewer from './MindARViewer'

const LandingLazy = lazy(() => import('./components/Landing/Landing'))

const {
  title,
  videos,
  volumeControl,
  buttonText,
  startMuted,
  mind,
  loadingBackground,
  loadingDotsColor
} = window.runConfig

function App() {
  const [cameraEnabled, setCameraEnabled] = useState(false)
  const [mute, setMute] = useState(startMuted)
  const [showVolumeControl, setShowVolumeControl] = useState(false)

  const enableCameraHandler = () => {
    setCameraEnabled(true)
  }

  const muteHandler = () => {
    setMute(!mute)
  }

  const toggleVolumeControl = (state) => {
    setShowVolumeControl(state)
  }

  useEffect(() => {
    document.title = title
  }, [])

  return (
    <React.Fragment>
      {!cameraEnabled && (
        <Suspense fallback={<PageLoader />}>
          <LandingLazy
            buttonHandler={enableCameraHandler}
            buttonText={buttonText}
          />
        </Suspense>
      )}

      {cameraEnabled && (
        <div className={css.Container}>
          <MindARViewer
            mute={mute}
            mind={mind}
            videos={videos}
            toggleVolumeControl={toggleVolumeControl}
            loadingDotsColor={loadingDotsColor}
            loadingBackground={loadingBackground}
          />
        </div>
      )}

      {cameraEnabled && volumeControl && showVolumeControl && (
        <button
          className={css.VolumeControl}
          onClick={muteHandler}
          aria-label='Mute/Unmute the video'
        >
          <i
            className={`fa-solid ${
              mute ? 'fa-volume-xmark' : 'fa-volume-high'
            }`}
          ></i>
        </button>
      )}
    </React.Fragment>
  )
}

export default App
